import { Check } from 'lucide-react';
import pluralize from 'pluralize';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { Modal, ModalContent, ModalTitle } from '../../../../../design-system/modal/modal';
import { Stack } from '../../../../../design-system/stack/stack';

type AccountConnectedSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  institutionName?: string;
  institutionLogo?: string;
  accountsCount?: number;
  onLinkAnotherAccount: () => void;
};

export const AccountConnectedSuccessModal = ({
  isOpen,
  onClose,
  institutionName,
  institutionLogo,
  accountsCount,
  onLinkAnotherAccount,
}: AccountConnectedSuccessModalProps) => {
  const modalTitle = institutionName ? `Your ${institutionName} Account is Connected` : 'Your Account is Connected';

  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-[414-px] w-[520px] overflow-visible bg-white px-10 py-12">
        {institutionLogo && (
          <div className="absolute left-1/2 h-14 w-14 -translate-x-1/2 -translate-y-1/2 overflow-clip rounded-full">
            <img
              src={institutionLogo}
              alt=""
              loading="eager"
              fetchpriority="high"
              className="h-full w-full object-cover"
            />
          </div>
        )}

        <Stack space={6} align="stretch">
          <Stack space={4} align="stretch">
            <Stack space={3} align="stretch">
              <ModalTitle className="text-center text-xl font-medium text-black">{modalTitle}</ModalTitle>

              {!!accountsCount && (
                <Inline space={1} justify="center">
                  <p className="text-sm font-semibold text-black">{`${accountsCount} ${pluralize('Account', accountsCount)} Connected`}</p>

                  <div className="h-4 w-4 text-success">
                    <Check className="h-full w-full" />
                  </div>
                </Inline>
              )}
            </Stack>

            <p className="text-center text-sm font-medium text-muted-foreground">
              Our AI will now start generating your transactions and preparing your first set of management reports.
            </p>
          </Stack>

          <Inline space={2}>
            <Button variant="default" size="default" onClick={onLinkAnotherAccount} className="flex-1">
              Link another account
            </Button>

            <Button variant="secondary" size="default" onClick={onClose} className="flex-1">
              I'm done linking
            </Button>
          </Inline>
        </Stack>
      </ModalContent>
    </Modal>
  );
};
